import { render } from "./PermissionMatrix.vue?vue&type=template&id=0e849a22&scoped=true"
import script from "./PermissionMatrix.vue?vue&type=script&lang=js"
export * from "./PermissionMatrix.vue?vue&type=script&lang=js"

import "./PermissionMatrix.vue?vue&type=style&index=0&id=0e849a22&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e849a22"]])

export default __exports__